/**
 * 大面积拖拽上传区组件
 * 紫色云图标，虚线边框，拖入变实线
 */
import React, { useState, useRef } from 'react';
import { CloudUploadOutlined, FileExcelOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import './FileDropzone.css';

const FileDropzone = ({ onFileSelect, accept, selectedFile }) => {
  const [dragging, setDragging] = useState(false);
  const inputRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
    const file = e.dataTransfer.files?.[0];
    if (file) onFileSelect(file);
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleChange = (e) => {
    const file = e.target.files?.[0];
    if (file) onFileSelect(file);
    e.target.value = '';
  };

  return (
    <div
      className={`file-dropzone ${dragging ? 'dragging' : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={handleChange}
        style={{ display: 'none' }}
      />
      <div className="file-dropzone-icon">
        <CloudUploadOutlined />
      </div>
      <div className="file-dropzone-title">
        点击或拖拽 Excel 文件到这里
      </div>
      <div className="file-dropzone-subtitle">
        支持 .xlsx, .xls 格式，最大 50MB
      </div>
      {selectedFile && (
        <div className="file-dropzone-selected">
          <Tag icon={<FileExcelOutlined />} color="green">
            {selectedFile.name}
          </Tag>
        </div>
      )}
    </div>
  );
};

export default FileDropzone;
